import { render, staticRenderFns } from "./commonForm.vue?vue&type=template&id=6331315b"
import script from "./commonForm.vue?vue&type=script&lang=js"
export * from "./commonForm.vue?vue&type=script&lang=js"
import style0 from "./commonForm.vue?vue&type=style&index=0&id=6331315b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports